"use strict";

var _classCallCheck = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MissingParametersError =
/*#__PURE__*/
function (_Error) {
  _inherits(MissingParametersError, _Error);

  function MissingParametersError(message) {
    var _this;

    _classCallCheck(this, MissingParametersError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MissingParametersError).call(this));
    _this.name = 'MissingParametersError';
    _this.message = message || '';
    return _this;
  }

  return MissingParametersError;
}(_wrapNativeSuper(Error));

exports.MissingParametersError = MissingParametersError;

var InvalidTokenError =
/*#__PURE__*/
function (_Error2) {
  _inherits(InvalidTokenError, _Error2);

  function InvalidTokenError(message) {
    var _this2;

    _classCallCheck(this, InvalidTokenError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidTokenError).call(this));
    _this2.name = 'InvalidTokenError';
    _this2.message = message || '';
    return _this2;
  }

  return InvalidTokenError;
}(_wrapNativeSuper(Error));

exports.InvalidTokenError = InvalidTokenError;